<template>
<div class="w-100 h-100 p-relative d-flex align-items-center">
  <div class="container container-uedahiraku">
    <b-row v-if="workshops.length > 1">
      <b-col md="12" lg="6" class="mb-3 mb-lg-0">
        <WorkshopCell :workshop="workshops[0]" size="lg" ref="cell1" />
      </b-col>
      <b-col md="12" lg="6">
        <b-row v-if="workshops.length > 1" class="xs-slim-gutters">
          <b-col v-if="workshops[1]" cols="6" md="4" lg="6" class="mb-4">
            <WorkshopCell v-if="workshops[1]" :workshop="workshops[1]" size="sm" ref="cell2"/>
          </b-col>
          <b-col v-if="workshops[2]" cols="6" md="4" lg="6" class="mb-4">
            <WorkshopCell v-if="workshops[2]" :workshop="workshops[2]" size="sm" ref="cell3" />
          </b-col>
          <b-col v-if="workshops[3]" cols="6" md="4" lg="6" class="d-none d-md-block mb-4">
            <WorkshopCell v-if="workshops[3]" :workshop="workshops[3]" size="sm" ref="cell4" />
          </b-col>
          <b-col v-if="workshops[4]" cols="6" class="d-none d-lg-block mb-4">
            <WorkshopCell v-if="workshops[4]" :workshop="workshops[4]" size="sm" ref="cell5" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
  <h2 class="right-title futura tracking-1">WORKSHOP</h2>
  <div class="right-item">
    <div class="tategaki font-weight-bold">
      お題の生き物をひとつ決め制作するワークショップを実施しています
    </div>
  </div>
</div>
</template>

<script>
import WorkshopCell from '@/components/WorkshopCell'

export default {
  name: 'Workshop',
  components: {
    WorkshopCell
  },

  data() {
    return {
      workshops: [],
      // isShown: false
    }
  },
  mounted() {
    this.getWorkshop()
  },
  methods: {
    async getWorkshop() {
      const payload = await this.axios.get(process.env.VUE_APP_API_BASE_URL + '/wp-json/wp/v2/workshop?_embed')
      .catch((e) => {
        console.log(e)
        this.workshops = []
      });
      if (payload.data) {
        console.log(payload.data)
        this.workshops = payload.data
      }
    }

  }
}
</script>

<style lang="scss" scoped>

</style>